(function(angular){
	'use strict';

	angular
		.module('historicalPerformanceChartModule')
		.directive('historicalPerformanceChart', [
			'$window',
			'HIGHCHARTS_OPTIONS', 
			historicalPerformanceChartFunction
		]);

	function historicalPerformanceChartFunction(
		$window,
		HIGHCHARTS_OPTIONS
	) {
		return {
			replace: true,
			restrict: 'E',
			scope: {
				theme: '@'
			},
			template: '<div id="historical-performance-chart" class="coterminous"></div>',
			link: function($scope) {
				var blueHex = '#3a9cfe';
				var darkerHex = '#003b77';

				var gradientStops;
				var fillColorStops;
				var labelColor;
				var lineColor;
				var tickColor;
				var gridLineColor;

				if(angular.isDefined($scope.theme) && $scope.theme === 'dark') {
					gradientStops = [
						[0, blueHex],
						[1, blueHex]
					];
					fillColorStops = [blueHex, blueHex];
					labelColor = '#FFFFFF';
					lineColor = blueHex;
					tickColor = blueHex;
					gridLineColor = darkerHex;
				} else {
					gradientStops = [
						[0, '#F6A01A'],
						[1, '#F47735']
					];
					fillColorStops = ['#FF6A19', '#F6A01A'];
					labelColor = 'hsl(210,5%,55%)';
					lineColor = 'hsl(210,10%,85%)';
					tickColor = 'hsl(210,10%,85%)';
					gridLineColor = 'hsl(210,10%,85%)';
				}

				var chartOptions = {
					chart: {
						renderTo: 'historical-performance-chart',
						type: 'area'
					},
					series: [{
						color: {
							linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
							stops: gradientStops
						},
						data: [{
							x: Date.UTC(2014,0,1),
							y: 0
						}, {
							x: Date.UTC(2015,0,1),
							y: 136416.96
						}, {
							x: Date.UTC(2016,0,1),
							y: 4253969.63
						}, {
							x: Date.UTC(2017,0,1), 
							y: 13491946.87
						}, {
							x: Date.UTC(2017,3,1),
							y: 18356101.83	
						}, {
							x: Date.UTC(2017,6,1),
							y: 23035809.30	
						}, {
							x: Date.UTC(2017,9,1),
							y: 27978046.60	
						}, {
							x: Date.UTC(2018,0,1),
							y: 34998052.89	
						}, {
							x: Date.UTC(2019,0,1),
							y: 66459611.75	
						}],
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, Highcharts.Color(fillColorStops[0]).setOpacity(0.5).get('rgba')],
								[1, Highcharts.Color(fillColorStops[1]).setOpacity(0).get('rgba')]
							]
						}
					}],
					xAxis: {
						type: 'datetime',
						labels: {
							style: {
								color: labelColor
							},
						},
						lineColor : lineColor,
						tickColor : tickColor
					},
					yAxis: {
						labels: {
							style: {
								color: labelColor
							},
							formatter: function() {
								return '$' + Highcharts.numberFormat((this.value / 1000000), 0) + 'M';
							}
						},
						gridLineColor : gridLineColor,
						lineColor : lineColor,
						tickColor : tickColor,
						max: 70000000,
						tickInterval: 10000000
					}
				};

				var highchartsOptions = angular.merge(HIGHCHARTS_OPTIONS(), chartOptions);
				var chart = new Highcharts.Chart(highchartsOptions);
			}
		};
	}
})(window.angular);